var map = {
	"./api-screenshot.png": "184b",
	"./arrow-up-white.svg": "97d6",
	"./benefit-card-bulk.svg": "61ed",
	"./benefit-card-dashboard.svg": "4177",
	"./benefit-card-dent.svg": "b75b",
	"./buy-packages-screenshot.png": "ddde",
	"./card1.svg": "b904",
	"./card2.svg": "cba9",
	"./card3.svg": "3e4f",
	"./credit-card-dent-red.svg": "51ff",
	"./crypto-dent-dent-red.svg": "a4db",
	"./gigastore-lp-api-mobile.png": "f362",
	"./gigastore-lp-api.png": "694b",
	"./gigastore-lp-pos-mobile.png": "4c91",
	"./gigastore-lp-pos.png": "85f8",
	"./gigastore-lp-sdk.png": "f2e9",
	"./link-arrow.svg": "75ba",
	"./long-arrow-white.svg": "2d2c1",
	"./paypal-dent-red.svg": "0786",
	"./sales-screenshot.png": "a225"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4c1d";